import React from 'react';
import { DEFAULT } from './theme';
import { createMedia } from '@artsy/fresnel';

export const { MediaContextProvider, Media: RawMedia } = createMedia({
  breakpoints: {
    sm: 0,
    md: DEFAULT.mobile,
    xmd: DEFAULT.tablet,
    lg: DEFAULT.desktop,
    xlg: 10000,
  },
});

export const Media = (props) => {
  const isServerSideRender = typeof window === 'undefined';
  if (isServerSideRender) {
    return <></>;
  }

  return <RawMedia {...props}></RawMedia>;
};
